import React from 'react';
import type { BreadcrumbLink } from '@noths/polaris-design-system-candidate-components';
import { Breadcrumbs } from '@noths/polaris-design-system-candidate-components';

import type { SeoProps } from 'src/components/atoms/Seo/Seo';
import { Seo } from 'src/components/atoms/Seo/Seo';
import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import type { TabLink } from 'src/components/molecules/Tabs/Tabs';
import { Tabs } from 'src/components/molecules/Tabs/Tabs';
import { SKIP_CONTENT_TARGET_ID } from 'src/constants/elementIds';
import { INSPIRATION_HUB_INTRO, INSPIRATION_HUB_TITLE } from './copy';
import * as styles from './InspirationLayout.styles';

export interface InspirationLayoutProps {
  activeTabId: string;
  breadcrumbs: BreadcrumbLink[];
  children: React.ReactNode;
  seo: SeoProps;
  tabs: TabLink[];
}

/** The heading and category tabs shared by the hub and every category page. */
export const InspirationLayout = ({
  activeTabId,
  breadcrumbs,
  children,
  seo,
  tabs,
}: InspirationLayoutProps) => (
  <div id={SKIP_CONTENT_TARGET_ID}>
    <Seo {...seo} />
    <SectionContainer columnsXL={10} maxWidth="max" wrapperStyles={styles.container}>
      <div css={styles.main}>
        <div css={styles.header}>
          <Breadcrumbs includesCurrentPage links={breadcrumbs} />
          <h1 css={styles.title}>{INSPIRATION_HUB_TITLE}</h1>
          <p css={styles.intro}>{INSPIRATION_HUB_INTRO}</p>
        </div>
        <Tabs activeId={activeTabId} ariaLabel="Inspiration categories" tabs={tabs} />
        <div css={styles.content}>{children}</div>
      </div>
    </SectionContainer>
  </div>
);
